import {Controller} from "stimulus";

// FormController
//
// Minimal Stimulus controller introduced to supersede HTML event handler
// attribute usage (e.g.: onchange, onclick, etc.).
//
// @example
//   <form data-controller="lighthouse--form" …>
//     <input type="checkbox" data-action="change->lighthouse--form#submit" …>
export default class FormController extends Controller<HTMLElement> {
  submit(event) {
    event.currentTarget.form?.requestSubmit();
  }
}
